import { render, staticRenderFns } from "./DeviceType.vue?vue&type=template&id=61a84f81"
import script from "./DeviceType.vue?vue&type=script&lang=js"
export * from "./DeviceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports